export default {
    selectAppNewsList: '/gateway/manageBedrock/free/newscs/selectAppNewsList', // 新闻列表查询
    querySafeList: '/gateway/manageBedrock/free/safecs/querySafeList', // 安全培训列表查询
}


// WEBPACK FOOTER //
// ./src/find/index/api.js